import React, { Fragment } from 'react';
import OurBlogs from '../../components/OurBlogs';
import Footer from '../../components/footer';
import PageTitle from '../../components/pagetitle';
import Scrollbar from '../../components/scrollbar';
import WithOutBlogSilder from '../../components/WithOutBlogSilder';

const BlogPage = () =>
{
  return (
    <Fragment>
      <PageTitle pageTitle={ 'Blog' } pagesub={ 'Blog' } />
      <WithOutBlogSilder />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default BlogPage;
